<!-- 指定签署位置 -->
<template>
    <div class="appoint-location">
        <template v-for="(rect, index) in rectangles">
            <div
                class="appoint-rect"
                v-show="pageNumber === rect.page"
                :class="{'has-bg': !rect.src, 'across-page': rect.rectType == 'ACROSS_PAGE'}"
                :data-page="rect.page"
                :style="rect.style"
                @dragover.stop="handleDragover($event, rect)"
                @drop.stop="handleDrop(rect)"
                @click="handleDrop(rect)"
                :key="index"
            >
                <template v-if="rect.src && rect.rectType !== 'TIMESTAMP'">
                    <img
                        :src="rect.src"
                        alt=""
                    >
                    <i
                        class="delete-icon el-icon-circle-close-outline"
                        @click.stop="handleDelete(rect)"
                    ></i>
                </template>
                <template v-else-if="rect.src && rect.rectType === 'TIMESTAMP'">
                    <div
                        class="appoint-time-rect"
                        @click="handleClickStatus(rect)"
                        v-click-outside="(e) => handleClickOutside(e, rect)"
                    >
                        <div
                            v-if="blockToolTimeAuth(rect)"
                            :style="blockToolStyle()"
                        >
                            <block-tool-time :block="rect"/>
                        </div>
                        <img
                            :src="rect.src"
                            alt=""
                        >
                    </div>
                </template>
                <span v-else>{{rect.label}}</span>
            </div>
        </template>
    </div>
</template>

<script>
import qs from 'qs';
import blockToolTime from './block-tool-time.vue';
import ToolBarStyle from '../utils/block-style';

export default {
    name: 'AppointRectangle',
    components: { blockToolTime },
    data () {
        return {};
    },
    props: {
        rectangles: Array,
        sealUrl: String,
        datePattern: String,
        sealId: String,
        verify: Boolean,
        isEtlType: Boolean,
        isPersonal: Boolean,
        isPDF: Boolean,
        isZWFWSEAL: Boolean,
        pageNumber: Number,
        leftControl: {
            type: Boolean,
            default: true,
        },
    },
    inject: ['signPage'],
    methods: {
        handleDragover (e) {
            e.preventDefault();
        },
        //工具栏样式
        blockToolStyle () {
            return new ToolBarStyle();
        },
        blockToolTimeAuth(rectangle) {
            return rectangle.isClicked && !rectangle['isAppointTimestampFormatType'];
        },
        // 时间戳图片
        getTimeStampImage (formatType = 'SECONDARY_THIRD') {
            const param = { formatType, zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token };
            return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
        },
        handleDrop (rect) {
            if (rect.rectType === 'TIMESTAMP') {
                return;
            }
            if ((this.verify || this.isPersonal) && this.sealUrl) {
                if (!this.isPDF && !this.isZWFWSEAL) {
                    this.$message.error("请使用有效的国办印章");
                    return;
                }
                this.$set(rect, 'src', this.sealUrl);
                this.$set(rect, 'sealId', this.sealId);
            } else {
                this.$message.error('当前没有可使用的印章！');
            }
        },
        handleClickStatus (rect) {
            this.$emit('resetStamperAndRectangles');
            this.$set(rect, 'isClicked', true);
        },
        handleClickOutside(e, rect) {
            this.$set(rect, 'isClicked', false);
        },
        handleDelete (rect) {
            this.$set(rect, 'src', '');
            this.$set(rect, 'sealId', '');
        }
    }
};
</script>

<style lang="less" scoped>
.appoint-location {
    .appoint-rect {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border: 2px dashed #2489F2;
        font-size: 14px;
        cursor: pointer;

        &.has-bg {
            background: rgba(197, 0, 1, 0.1);
        }
        img {
            width: 100%;
        }
        .appoint-time-rect {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .delete-icon {
        position: absolute;
        top: -8px;
        right: -8px;
        background: @white;
        z-index: 1000;
        cursor: pointer;
    }
}
</style>
